document.addEventListener('DOMContentLoaded', function() {
  var ua = window.navigator.userAgent;
  var isInternetExplorer = ua.indexOf('MSIE ') > -1 || !!ua.match(/Trident.*rv:11\./);
  var isOperaMini =
    ua.indexOf('Opera Mini') > -1 || Object.prototype.toString.call(window.operamini) === '[object OperaMini]';
  if (isOperaMini || isInternetExplorer) {
    // Show browser warning banner
    const unsupportedBrowserEl = document.getElementById('unsupported-browser-warning');
    unsupportedBrowserEl.style.display = 'block';
    unsupportedBrowserEl.querySelector('.close').addEventListener('click', () => {
      unsupportedBrowserEl.style.display = 'none';
    });
    alert(
      'Diese Webseite ist nicht kompatibel mit Ihrem Browser. Wechseln Sie zu einer aktuellen Version von Chrome, Firefox oder Safari, um diese fehlerfrei nutzen zu können.'
    );
  }
});
